import service from "@/utils/service"

//获取用户列表,无参数时查询所有
export function getUserList(data) {
  return service({
    url: "/sys/user/view",
    method: "post",
    data: data
  })
}

//添加用户
export function createUser(data) {
  return service({
    url: "/sys/user/add",
    method: "post",
    data: data
  })
}

//编辑用户信息
export function updateUser(data) {
  return service({
    url: "/sys/user/edit",
    method: "post",
    data: data
  })
}

//更新用户密码
export function updateUserPassword(userId, password_arr) {
  return service({
    url: "/sys/user/editpasswd",
    method: "post",
    data: { userId, password_arr }
  })
}

export function updateUserImg(data) {
  return service({
    url: "/sys/user/updateimg",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

//删除用户
export function deleteUser(data) {
  return service({
    url: "/sys/user/del",
    method: "post",
    data: data
  })
}

//添加，编辑用户的时候，有一个角色权限需要从后台获取
export function getRoleOptions() {
  return service({
    url: "/sys/user/getroleoptions",
    method: "get"
  })
}
